/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateBlockadeMonthExceptionDto
 */
export interface CreateUpdateBlockadeMonthExceptionDto {
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    date?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    isSalesUnblocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    isPurchaseUnblocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    projectId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    dateToDelete?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateBlockadeMonthExceptionDto
     */
    reason: string;
}

/**
 * Check if a given object implements the CreateUpdateBlockadeMonthExceptionDto interface.
 */
export function instanceOfCreateUpdateBlockadeMonthExceptionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isSalesUnblocked" in value;
    isInstance = isInstance && "isPurchaseUnblocked" in value;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function CreateUpdateBlockadeMonthExceptionDtoFromJSON(json: any): CreateUpdateBlockadeMonthExceptionDto {
    return CreateUpdateBlockadeMonthExceptionDtoFromJSONTyped(json, false);
}

export function CreateUpdateBlockadeMonthExceptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateBlockadeMonthExceptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
        'isSalesUnblocked': json['isSalesUnblocked'],
        'isPurchaseUnblocked': json['isPurchaseUnblocked'],
        'projectId': json['projectId'],
        'active': json['active'],
        'dateToDelete': !exists(json, 'dateToDelete') ? undefined : (new Date(json['dateToDelete'])),
        'reason': json['reason'],
    };
}

export function CreateUpdateBlockadeMonthExceptionDtoToJSON(value?: CreateUpdateBlockadeMonthExceptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
        'isSalesUnblocked': value.isSalesUnblocked,
        'isPurchaseUnblocked': value.isPurchaseUnblocked,
        'projectId': value.projectId,
        'active': value.active,
        'dateToDelete': value.dateToDelete === undefined ? undefined : (value.dateToDelete.toISOString()),
        'reason': value.reason,
    };
}

